/* Initialize re-usable variable declarations */
var addOnsData, pdpaAddonsData, addOnsPricingData, cartHandles, pdpAddOnsPricingData, mainVariantsData, organisedAddonData, pdpaOrganisedAddonData, scaCategories, scaAddOnSwiperInstances, pdpaAddOnSwiperInstances, scaRandomNumber, pdpaRandomNumber, scaAddOnsWindowWidth, addOnProductDataSideCart, pdpaCategories, pdpaLeftRightNavHtml;


/* Initialize element declarations */
var scaHeaderContainer, scaCartWrapper, scaAddonsContainer, pdpaAddonsContainer, scaAddonsOriginal, pdpaAddonsOriginal, scaTabsContainer, pdpaTabsContainer, scaInnerContainer, pdpaInnerContainer;
var sideCartAddonsReusableVariablesInitialized = false;

window.Branch = window.Branch || {};
window.Branch.addons = window.Branch.addons || {};

function initSideCartAddonsReusableVariableDeclarations(){
    if(sideCartAddonsReusableVariablesInitialized == false){
        sideCartAddonsReusableVariablesInitialized = true;

        /* Assign values to element declarations */
        scaHeaderContainer = document.querySelector('.addons__side-cart-header-container');
        scaCartWrapper = document.querySelector('.addons__side-cart-wrapper');
        scaAddonsContainer = scaCartWrapper && scaCartWrapper.querySelector('.addons__container');
        scaAddonsOriginal = scaCartWrapper && scaCartWrapper.querySelector('.addons-original');
        scaTabsContainer = scaCartWrapper && scaCartWrapper.querySelector('.addons__tabs-container');
        scaInnerContainer = scaCartWrapper && scaCartWrapper.querySelector('.addons__inner-container');

        pdpaAddonsContainer = document.querySelector('.main-product__item[data-quick-view="false"] .addons__container');
        pdpaAddonsOriginal = pdpaAddonsContainer && pdpaAddonsContainer.querySelector('.addons-original');
        pdpaTabsContainer = pdpaAddonsContainer && pdpaAddonsContainer.querySelector('.addons__tabs-container');
        pdpaInnerContainer = pdpaAddonsContainer && pdpaAddonsContainer.querySelector('.addons__inner-container');
        pdpaCategories = [];

        /* Assign values to re-usable variable declarations */

        mainVariantsData = document.querySelector(`#variant_data-side-cart`) ? JSON.parse(document.querySelector(`#variant_data-side-cart`).innerText) : {};
        addOnsData = document.querySelector(`#full-side-cart-addons-data`) ? JSON.parse(document.querySelector(`#full-side-cart-addons-data`).innerText) : [];
        addOnProductDataSideCart = document.querySelector(`#add_on_product_data-side-cart`) ? JSON.parse(document.querySelector(`#add_on_product_data-side-cart`).innerText) : {};
        cartHandles = document.querySelectorAll('.cart-items form > .item').length > 0 ? [...document.querySelectorAll('.cart-items form > .item')].map(item => item.dataset.productHandle) : [];

        addOnsData = addOnsData.filter(item => !cartHandles.includes(item.h));

        /* Special check for cable organizer */
        if (cartHandles.includes('cable-organizer-tray') || cartHandles.includes('cable-organizer-power')) {
            addOnsData = addOnsData.filter(item => item.h !== 'cable-organizer');
        }

        pdpaMainProductAddonData = document.querySelector(`#main-product-addon-data`) ? JSON.parse(document.querySelector(`#main-product-addon-data`).innerText) : {};
        pdpaAddonsData = document.querySelector(`#full-pdp-addons-data`) ? JSON.parse(document.querySelector(`#full-pdp-addons-data`).innerText) : [];        
        organisedAddonData = addOnsData.length > 0 ? returnOrganisedAddonData('side-cart') : [];
        pdpaOrganisedAddonData = pdpaAddonsData.length > 0 ? returnOrganisedAddonData('pdp') : [];

        addOnsPricingData = document.querySelector(`#full-side-cart-addons-pricing-data`) ? JSON.parse(document.querySelector(`#full-side-cart-addons-pricing-data`).innerText) : {};
        scaAddOnSwiperInstances = [];
        pdpaAddOnSwiperInstances = [];
        scaRandomNumber = scaCartWrapper ? scaCartWrapper.querySelector('.addons__container ').getAttribute('data-id') : null;
        pdpaRandomNumber = pdpaAddonsContainer ? pdpaAddonsContainer.getAttribute('data-id') : null;
        
        pdpaLeftRightNavHtml= `<div class="addons__nav-left swiper-button-prev"><svg aria-hidden="false" tabindex="-1" role="presentation" class=" icon icon-chevron" viewBox="0 0 32 32"><path fill="#314438" fill-rule="evenodd" clip-rule="evenodd" d="M21.1199 16L7 1.93279L8.94004 0L25 16L8.94004 32L7 30.0672L21.1199 16Z"></path></svg></div><div class="addons__nav-right swiper-button-next"><svg aria-hidden="false" tabindex="-1" role="presentation" class=" icon icon-chevron" viewBox="0 0 32 32"><path fill="#314438" fill-rule="evenodd" clip-rule="evenodd" d="M21.1199 16L7 1.93279L8.94004 0L25 16L8.94004 32L7 30.0672L21.1199 16Z"></path></svg></div>`
        pdpAddOnsPricingData = document.querySelector(`#full-pdp-addons-pricing-data`) ? JSON.parse(document.querySelector(`#full-pdp-addons-pricing-data`).innerText) : {};
    }
}

const updateObjectsWithRatio = function(position) {
    if(position == 'side-cart'){
    addOnsData.forEach((obj) => {
        obj.ratio = 1;
        const mainVariant = mainVariantsData[`${obj.mpv}`];

        if (mainVariant && Array.isArray(mainVariant.addon_matches)) {
            const addonMatch = mainVariant.addon_matches.find(match => match['add-on-handle'] === obj.h);

            if (addonMatch && addonMatch['quantity-ratio']) {
                obj.ratio = addonMatch['quantity-ratio'];
            }
        }
    });
    } else {
        if(pdpaAddonsData && pdpaAddonsData.length > 0){
            pdpaAddonsData.forEach((obj) => {
                obj.ratio = 1;
                if(pdpaMainProductAddonData && Array.isArray(pdpaMainProductAddonData.addon_matches)){
                    const addonMatch = pdpaMainProductAddonData.addon_matches.find(match => match['add-on-handle'] === obj.h);
                    if (addonMatch && addonMatch['quantity-ratio']) {
                        obj.ratio = addonMatch['quantity-ratio'];
                    }
                }
            });
        }
    }
}

const returnItemHtml = function (recommendedAddon, position){
    // console.log('recommendedAddon', recommendedAddon)
    let pricingData = position == 'side-cart' ? addOnsPricingData[`${recommendedAddon.id}`][`${recommendedAddon.dvid}`] : pdpAddOnsPricingData[`${recommendedAddon.id}`][`${recommendedAddon.dvid}`];
    let itemHtml = `
        <div class="item swiper-slide" data-product-handle="${recommendedAddon.h}" data-quantity-ratio="${recommendedAddon.ratio}" data-main-product-variant="${recommendedAddon.mpv}">
            <input class="checkbox-custom" id="${position == 'side-cart' ? `cart-addon-${recommendedAddon.id}` : `addon-${recommendedAddon.id}`}" type="checkbox" aria-hidden="true" data-addon-id="${recommendedAddon.id}">
            <label class="checkbox-custom-label quick-view-link" role="button" for="cart-addon-${recommendedAddon.id}" data-addon-handle="${recommendedAddon.h}" data-addon-id="${recommendedAddon.id}" data-addon-price="${recommendedAddon.p}" data-url="/products/${recommendedAddon.h}?view=quick-view" data-bundle="${recommendedAddon.b}">
                <div class="addon-img" data-lifestyle-image-url="${recommendedAddon.li}">
                    <div class="addon-img-inner">
                        <img draggable="false" src="${recommendedAddon.di}" width="500" height="500" srcset="${window.Branch.functions.returnSrcSet(recommendedAddon.di)}" sizes="(min-width: 600px) calc((344px - ((2.25 - 1) * 10px)) / 2.25), calc(((100vw - 56px) - ((2.25 - 1) * 10px)) / 2.25)" alt="${recommendedAddon.pt};" loading="lazy">
                        ${recommendedAddon.sbt && recommendedAddon.sbt.length > 0 ? `<div ${recommendedAddon.ps == "true" ? 'promo-style="true" promo-style-on-hover="true"' : ''} class="addon-sale">${recommendedAddon.sbt}</div>` : ''}
                    </div>                  
                </div>
                <span class="visuallyhidden">Add </span>
                <span class="flex-1 ${position == 'pdp' ? 'addons_info-container' : ''}">
                        <span class="addontitle animation" ${position == 'pdp' ? `data-addon-id="${recommendedAddon.id}" data-addon-price="${pricingData.cpx}"`: ''}>${recommendedAddon.pt} ${recommendedAddon.ratio > 1 ? `x${recommendedAddon.ratio}` : ''}</span>
                        <span class="subtitle">${recommendedAddon.st.replaceAll('&quot;', '"')}</span>
                        <div class="price " data-discount-code-amount="${pricingData.dcax}" data-discount-code-message="${pricingData.dcmx && pricingData.dcmx != '' ? 'true' : 'false'}" data-addon="true">
                            <div class="retail" data-visible="${pricingData.opx && pricingData.opx != pricingData.cpx ? "true" : "false"}">
                            <span data-price="retail">${pricingData.opx && pricingData.opx != pricingData.cpx ? `$${Math.round(pricingData.opx / 100)}` : "$0"}</span></div>
                            <div class="deal">
                            <span class="addon-price" data-price="deal">+$${Math.round(pricingData.cpx / 100)}</span></div>
                        </div>
                </span>
                ${position == 'side-cart' ?
                `<span class="sidecart-addon__icon"><svg aria-hidden="true" tabindex="-1" role="presentation" class=" icon icon-addon-plus" viewBox="0 0 32 32"><circle e="" cx="16" cy="16" r="15.5" fill="transparent" stroke="#314438"></circle><path d="M15.7768 22.1031H17.373V16.9878H22.4883V15.401H17.373V10.2857H15.7768V15.401H10.6616V16.9878H15.7768V22.1031Z" fill="#314438"></path></svg></span>`
                :
                `<div class="callout-variant-add-button-container"><button class="callout-variant-add-button callout-variant-add-button--add"><svg aria-hidden="false" tabindex="-1" role="presentation" class=" icon icon-addon-plus" viewBox="0 0 32 32"><circle e="" cx="16" cy="16" r="15.5" fill="transparent" stroke="#314438"></circle><path d="M15.7768 22.1031H17.373V16.9878H22.4883V15.401H17.373V10.2857H15.7768V15.401H10.6616V16.9878H15.7768V22.1031Z" fill="#314438"></path></svg><svg aria-hidden="false" tabindex="-1" role="presentation" class=" icon icon-addon-tick" viewBox="0 0 32 32" fill="white"><path d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z" fill="#8DC0D2"></path><path d="M14.2858 18.7187L22.1647 10.839L23.3775 12.051L14.2858 21.1427L8.83096 15.6879L10.043 14.4759L14.2858 18.7187Z" fill="#ffffff"></path></svg></button></div>`
                }
                </label>
        </div>`;
    
    return itemHtml;
}

const returnTabButtonHtml = function(tab, index){
    let tabButtonHtml = `
        <button class="addons__tabs-button" data-type="${tab.toLowerCase()}" data-index="${index}">
          <span class="addons__tabs-button-text">${tab.toUpperCase()}</span>
          <span class="addons__tabs-loading-stand-in"></span>
        </button>`;

    return tabButtonHtml;
}

const returnCategorySwiperHtml = function(category, position){
    // console.log('category', category)
    let categorySwiperHtml = `${position == 'pdp' ? `<div class="addons-container" data-type="${category.category}">` : ''}<div class="${position == 'side-cart' ? 'addons-container' : ''} swiper ${position == 'pdp' ? 'addons new' : ''}" data-addons-length="${category.items.length}" data-type="${category.category}"><div class="swiper-wrapper ${position == 'pdp' ? 'wrap' : ''}">
    ${category.items
        .map((item) => returnItemHtml(item, position))
        .join('')
    }
    </div></div>${position == 'pdp' ? pdpaLeftRightNavHtml : ''}
    ${position == 'pdp' ? '</div>' : ''}`;

    return categorySwiperHtml;
}

const createInnerContainer = function(position){
    console.log('createInnerContainer')
    let data = position == 'side-cart' ? organisedAddonData : pdpaOrganisedAddonData;

    // console.log('data', data)

    let innerContainerHtmlToInsert = `
        ${data.recommended.length > 0 ? `${position == 'pdp' ? `<div class="addons-container" data-type="recommended">` : ''}<div class="${position == 'side-cart' ? 'addons-container' : ''}  swiper ${position == 'pdp' ? 'addons new' : ''}" data-addons-length="${data.recommended.length}" data-type="recommended"><div class="swiper-wrapper ${position == 'pdp' ? 'wrap' : ''}">
            ${data.recommended
                    .map((recommendedAddon) => returnItemHtml(recommendedAddon, position))
                    .join('')
                }
        </div></div>${position == 'pdp' ? pdpaLeftRightNavHtml : ''}
        ${position == 'pdp' ? '</div>' : ''}` : ''}
        
        ${data.categories
            .map((category) => returnCategorySwiperHtml(category, position))
            .join('')}
    `;
    if(position == 'side-cart'){
        scaInnerContainer.innerHTML = innerContainerHtmlToInsert;
        let first_category = data.recommended.length > 0 ? 'recommended' : data.categories.length > 0 ? data.categories[0].category : 'recommended';
        scaInnerContainer.closest('.addons__container').setAttribute('data-type-selected', first_category)
    } else {
        pdpaInnerContainer.innerHTML = innerContainerHtmlToInsert;
    }
}

const createTabsContainer = function(position){
    let tabsArray = position == 'side-cart' ? organisedAddonData.recommended.length > 0 ? ['recommended', ...scaCategories] : [...scaCategories] : pdpaOrganisedAddonData.recommended.length > 0 ? ['recommended', ...pdpaCategories] : [...pdpaCategories];
    
    let tabsElementHtmlToInsert = `
    <div class="addons__tabs-container">
            <div class="addons__tabs-inner-container">
                ${tabsArray
                    .map((tab, index) => returnTabButtonHtml(tab, index))
                    .join('')
                }
                <div class="addons__underline">
                    <div class="addons__blue-underline" data-index="0"></div>
                    <div class="addons__grey-underline"></div>
                </div>
            </div>
    </div>
    `;
    if(position == 'side-cart'){
        scaTabsContainer.innerHTML = tabsElementHtmlToInsert;
    } else {
        pdpaTabsContainer.innerHTML = tabsElementHtmlToInsert;
    }
}

const createOriginalElement = function(position){
    
    let originalElementHtmlToInsert = `
    ${position == 'pdp' ? `<div class="addons-container" data-type="original">` : ''} 
        <div class="${position == 'side-cart' ? 'addons-container' : ''} swiper ${position == 'pdp' ? 'addons new' : ''}"  data-addons-length="${position == 'side-cart' ? organisedAddonData.recommended.length : pdpaOrganisedAddonData.recommended.length}" data-type="original">
            <div class="head" aria-hidden="true">
            ${position == 'pdp' ? `
                <article>Accessories:</article><article class="addon_Count">${pdpaOrganisedAddonData.recommended.length} item${pdpaOrganisedAddonData.recommended.length > 1 ? 's' : ''}</article>` :
                `<span>Accessories:</span>`}
            </div>
                <div class="swiper-wrapper ${position == 'pdp' ? 'wrap' : ''}">
                ${position == 'side-cart' ? 
                    organisedAddonData.recommended
                    .map((recommendedAddon) => returnItemHtml(recommendedAddon, position))
                    .join('') : 
                    pdpaOrganisedAddonData.recommended
                    .map((recommendedAddon) => returnItemHtml(recommendedAddon, position))
                    .join('')
                }
                </div>
        </div>
        ${position == 'pdp' ? pdpaLeftRightNavHtml : ''}
        ${position == 'pdp' ? '</div>' : ''}`;
    if(position == 'side-cart'){
        scaAddonsOriginal.innerHTML = originalElementHtmlToInsert;
    } else {
        pdpaAddonsOriginal.innerHTML = originalElementHtmlToInsert;
    }
}

const updateOrganisedDataObject = function(position, organisedAddonData, categoriesArray){
    if(position == 'side-cart' && addOnsData.length > 0 || position == 'pdp' &&  pdpaAddonsData.length > 0){
        let categories = position == 'side-cart' ? [...scaCategories] : [...pdpaCategories];
        let data = position == 'side-cart' ? JSON.parse(JSON.stringify(addOnsData)) : JSON.parse(JSON.stringify(pdpaAddonsData));
        
        organisedAddonData.categories = categories.map(category => {
            const seenH = new Set(); 
            
            return {
                category: category,
                items: data.filter(addOn => {
                    if (addOn.c.includes(category) && !seenH.has(addOn.h)) {
                        seenH.add(addOn.h); 
                        return true;
                    }
                    return false; 
                })
            };
        });

        organisedAddonData.recommended = (() => {
            const seenH = new Set(); 
            return data.filter(addOn => {
                if (addOn.r == 'true' && !seenH.has(addOn.h)) {
                    seenH.add(addOn.h);
                    return true;
                }
                return false; 
            });
        })();
    }

    for (let i = organisedAddonData.categories.length - 1; i >= 0; i--) {
        if (organisedAddonData.categories[i].items.length === 0) {

            // Remove the category from pdpaCategories
            const categoryToRemove = organisedAddonData.categories[i].category;
            const categoryIndex = categoriesArray.indexOf(categoryToRemove);
            if (categoryIndex !== -1) {
                categoriesArray.splice(categoryIndex, 1);
            }

            organisedAddonData.categories.splice(i, 1);
        }
    }
}

const returnOrganisedAddonData = function(position){
    let organisedAddonData = {"recommended": [], "categories": []};
    if(position == 'side-cart'){
        scaCategories = [...new Set(Object.values(mainVariantsData).flatMap(o => o.addon_categories_to_show))];
    } else {
        pdpaCategories = pdpaMainProductAddonData.addon_categories_to_show;
    }

    updateObjectsWithRatio(position);
    updateOrganisedDataObject(position, organisedAddonData, position == 'side-cart' ? scaCategories : pdpaCategories);

    if(position == 'side-cart'){
        scaCartWrapper.setAttribute('data-addons-length', new Set(addOnsData.map(obj => obj.h)).size)
        scaCartWrapper.setAttribute('data-carousel-quantity', scaCategories.length + 1);
        scaAddonsContainer.setAttribute('data-carousel-quantity', scaCategories.length + 1);
    } else {
        pdpaAddonsContainer.setAttribute('data-carousel-quantity', pdpaCategories.length + 1);
    }

    return organisedAddonData;
}

const addonsInitSwipers = function(position){
    let swipersArray = position == 'side-cart' ? organisedAddonData.recommended.length > 0 ? ['original', 'recommended', ...scaCategories] : ['original', ...scaCategories] : pdpaOrganisedAddonData.recommended.length > 0 ? ['original', 'recommended', ...pdpaCategories] : ['original', ...pdpaCategories];
    swipersArray.forEach((type) => {
        if(position == 'side-cart'){
            window.Branch.addons.initAddonSwipers('.cart-items', type, 'side-cart', scaAddOnSwiperInstances, swipersArray);
        } else {
            window.Branch.addons.initAddonSwipers('.main-product__item[data-quick-view="false"] .add-to-cart-form', type, 'pdp', pdpaAddOnSwiperInstances, swipersArray);
        }
    });
}

const insertDynamicStyles = function(randomNumber, typesSize, types, position) {
    // Create a new style element
    const styleElement = document.createElement('style');
    styleElement.type = 'text/css';

    // Build the initial styles
    let styleContent = `
        .addons__container[data-id="${randomNumber}"] .addons__tabs-button {
            min-width: ${100 / typesSize}%;
        }

        .addons__container[data-id="${randomNumber}"] .addons__blue-underline {
            width: ${100 / typesSize}%;
        }
    `;

    // Loop through the types array to generate dynamic styles
    types.forEach((type) => {
        styleContent += `
            .addons__container[data-type-selected="${type}"][data-id="${randomNumber}"] .addons-container:not([data-type="${type}"]) {
                visibility: hidden;
                overflow: hidden;
                height: 0;
            }

            #side-cart .addons__container[data-type-selected="${type}"][data-id="${randomNumber}"] .addons-container:not([data-type="${type}"]) .item {
                height: fit-content;
            }

            #side-cart .addons__container[data-type-selected="${type}"][data-id="${randomNumber}"] .addons-container:not([data-type="${type}"]):not([data-type="original"]) .checkbox-custom-label {
                display: block;
                height: auto;
            }

            #side-cart .addons__container[data-type-selected="${type}"][data-id="${randomNumber}"] .addons__tabs-button:not([data-type="${type}"]),
            .addons__container[data-type-selected="${type}"][data-id="${randomNumber}"] .addons__tabs-button:not([data-type="${type}"]) {
                color: var(--primary-green-50);
            }
        `;
    });

    // Append the final set of styles
    styleContent += `
        .addons__container[data-type-selected][data-id="${randomNumber}"] .addons-original .addons-container {
            visibility: visible;
            overflow: visible;
            height: auto;
        }
    `;

    // Set the generated style content
    styleElement.textContent = styleContent;

    // Insert the style element before a specific element, e.g., before a script tag
    
    if(position == 'side-cart'){
        scaCartWrapper.parentNode.insertBefore(styleElement, scaCartWrapper);
    } else {
        pdpaAddonsContainer.parentNode.insertBefore(styleElement, pdpaAddonsContainer);
    }
}

const scaInitResizeEventListeners = function(){
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if(scaAddOnsWindowWidth != window.innerWidth){
            if(scaCartWrapper){
                window.Branch.addons.initAddonStyling('side-cart', scaRandomNumber);
            }
            if(pdpaAddonsContainer){
                window.Branch.addons.initAddonStyling('pdp', pdpaRandomNumber);
            }
            scaAddOnsWindowWidth = window.innerWidth;
          }
        }, 200); 
    });
}

const addonsInitSwipeOnTabsCarousel = function(position){
    let element = position == 'pdp' ? document.querySelector('.main-product__item .addons__container > .addons__tabs-container') : document.querySelector('#side-cart .addons__container > .addons__tabs-container'); 
    let startX = 0;
    let isTouch = false;
    function handleStart(event) {
        isTouch = event.type === 'touchstart';
        startX = isTouch ? event.touches[0].clientX : event.clientX;
    }

    function handleEnd(event) {
        let endX = isTouch ? event.changedTouches[0].clientX : event.clientX;
        let deltaX = endX - startX;
        const SWIPE_THRESHOLD = 50;
        if (Math.abs(deltaX) >= SWIPE_THRESHOLD) {
            const direction = deltaX > 0 ? 'right' : 'left';
            window.Branch.addons.handleTabClick(null, direction, element);
        }
    }

    element.addEventListener('touchstart', handleStart, { passive: true });
    element.addEventListener('touchend', handleEnd, { passive: true });
    element.addEventListener('mousedown', handleStart);
    element.addEventListener('mouseup', handleEnd);
}

const scaSelectImageOnLoad = function(){
    document.querySelectorAll('#side-cart .addons__side-cart-wrapper .item').forEach((item) => {
        let selectedProductId = item.getAttribute('data-main-product-variant');
        let selectedProduct = JSON.parse(document.querySelector(`#variant_data-side-cart`).innerText)[`${item.getAttribute('data-main-product-variant')}`];
        let addOnHandle = item.getAttribute('data-product-handle');
        let addOnProduct = addOnProductDataSideCart[`${item.querySelector('input.checkbox-custom').getAttribute('data-addon-id')}`]
        // console.log('selectedProductId', selectedProductId);
        // console.log('selectedProduct', selectedProduct);
        // console.log('addOnHandle', addOnHandle);
        // console.log('addOnProduct', addOnProduct)
        window.Branch.cart.updateSideCartImages(selectedProductId, selectedProduct, addOnHandle, addOnProduct)
    });
}

const preventClickAndDragOnPdpDesktop = function(){
    pdpaInnerContainer.addEventListener('dragstart', (e) => {
        if(scaAddOnsWindowWidth >= 900){
            e.preventDefault();
        }
    });
}

window.Branch.addons.sideCartAddonsInit = function(){
    sideCartAddonsReusableVariablesInitialized = false;
    initSideCartAddonsReusableVariableDeclarations();
    if(scaCartWrapper && addOnsData.length > 0){
        createOriginalElement('side-cart');
        createTabsContainer('side-cart');
        createInnerContainer('side-cart');
        addonsInitSwipers('side-cart');
        addonsInitSwipeOnTabsCarousel('side-cart');
        let stylesArray = organisedAddonData.recommended.length > 0 ? ['recommended', ...scaCategories] : [...scaCategories];
        insertDynamicStyles(scaRandomNumber, stylesArray.length, stylesArray, 'side-cart');
        window.Branch.addons.initAddonStyling('side-cart', scaRandomNumber);
    
        document.querySelectorAll('#side-cart .addons__tabs-button').forEach((button) => {
        button.addEventListener('click', window.Branch.addons.handleTabClick);
        });

        document.querySelectorAll('#side-cart .addons__side-cart-header-container').forEach((button) => {
            button.addEventListener('click', window.Branch.addons.handleButtonClick);
        });
        scaSelectImageOnLoad();
        window.Branch.addons.addOnLifestyleOnHover('side-cart', scaRandomNumber);
        setTimeout(function(){
            window.Branch.addons.initAddonStyling('side-cart', scaRandomNumber);
        }, 3000);
    }
    scaInitResizeEventListeners();
}

window.Branch.addons.pdpAddonsInit = function(){
    createOriginalElement('pdp');
    createTabsContainer('pdp');
    createInnerContainer('pdp');
    addonsInitSwipers('pdp');
    addonsInitSwipeOnTabsCarousel('pdp');
    let stylesArray = pdpaOrganisedAddonData.recommended.length > 0 ? ['recommended', ...pdpaCategories] : [...pdpaCategories];
    insertDynamicStyles(pdpaRandomNumber, stylesArray.length, stylesArray, 'pdp');
    window.Branch.addons.initAddonStyling('pdp', pdpaRandomNumber);
    document.querySelectorAll('.main-product__item[data-quick-view="false"] .addons__tabs-button').forEach((button) => {
        button.addEventListener('click', window.Branch.addons.handleTabClick);
      });
    window.Branch.addons.addOnLifestyleOnHover('pdp', pdpaRandomNumber);
    preventClickAndDragOnPdpDesktop();

    if (document.querySelector('.addons__container .addons .item input')) {
        const changeEvent = new Event('change', { bubbles: true });
        document.querySelector('.addons__container .addons .item input').dispatchEvent(changeEvent);
    }
}

window.Branch.addons.addonsInit = function(){
    window.Branch.addons.sideCartAddonsInit();
    if(document.querySelector('body.templateProduct') && document.querySelector('.main-product__item[data-quick-view="false"] .addons__container') && pdpaAddonsData.length > 0){
        window.Branch.addons.pdpAddonsInit();
    }
}

window.addEventListener('load', window.Branch.addons.addonsInit);

const targetElement = document.getElementById('addons-test-side-cart');

